class SearchTypingPlaceholder {
  constructor(container) {
    this.container = container;
    this.target = container.querySelector('[data-typing-target]');
    this.words = (container.dataset.typingWords || '')
      .split(',')
      .map((word) => word.trim())
      .filter(Boolean);

    if (!this.target || this.words.length === 0) return;

    this.typingSpeed = 90;
    this.deletingSpeed = 45;
    this.pauseBeforeDelete = 1400;
    this.pauseBeforeType = 300;

    this.wordIndex = 0;
    this.charIndex = this.words[0].length;
    this.isDeleting = true;
    this.timer = null;

    if (this.prefersReducedMotion()) {
      this.target.textContent = this.words[0];
      return;
    }

    this.timer = setTimeout(() => this.tick(), this.pauseBeforeDelete);
  }

  prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  tick() {
    const currentWord = this.words[this.wordIndex];

    if (this.isDeleting) {
      this.charIndex--;
      this.target.textContent = currentWord.slice(0, this.charIndex);

      if (this.charIndex <= 0) {
        this.isDeleting = false;
        this.wordIndex = (this.wordIndex + 1) % this.words.length;
        this.timer = setTimeout(() => this.tick(), this.pauseBeforeType);
        return;
      }
    } else {
      this.charIndex++;
      this.target.textContent = currentWord.slice(0, this.charIndex);

      if (this.charIndex >= currentWord.length) {
        this.isDeleting = true;
        this.timer = setTimeout(() => this.tick(), this.pauseBeforeDelete);
        return;
      }
    }

    this.timer = setTimeout(() => this.tick(), this.isDeleting ? this.deletingSpeed : this.typingSpeed);
  }

  destroy() {
    if (this.timer) clearTimeout(this.timer);
  }
}

// Initializes every not-yet-initialized [data-typing-words] element found
// within `root` (defaults to the whole document). Safe to call more than
// once, and safe to call after new markup (e.g. a lazily-hydrated drawer
// tab) has been inserted into the page.
window.initTypingPlaceholders = function (root) {
  (root || document).querySelectorAll('[data-typing-words]').forEach((container) => {
    if (container.dataset.typingInitialized === 'true') return;
    container.dataset.typingInitialized = 'true';
    new SearchTypingPlaceholder(container);
  });
};

document.addEventListener('DOMContentLoaded', () => {
  window.initTypingPlaceholders(document);

  // Safety net: automatically picks up any [data-typing-words] element
  // that gets added to the page later (e.g. a lazily-hydrated drawer tab),
  // even if nothing explicitly calls initTypingPlaceholders() for it.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-typing-words]')) {
          window.initTypingPlaceholders(node.parentNode || document);
        }
        if (node.querySelectorAll) {
          window.initTypingPlaceholders(node);
        }
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
});